import callAPI from '../ApiConfig'
import Cookies from 'universal-cookie'

const cookies = new Cookies()

// Helper function to get auth params from cookies
const getAuthParams = () => {
    return {
        username: cookies.get('user_name'),
        user_id: cookies.get('user_id'),
        account_name: cookies.get('account_name'),
        account_id: cookies.get('account_id'),
        sid: cookies.get('sid'),
        baseurl: cookies.get('baseUrl'),
        id: cookies.get('id'),
    }
}

const getContractors = async (props) => {
    return await callAPI({
        route: "contractors/",
        method: "get",
        signal: props?.signal,
        params: {
            ...getAuthParams(),
            ...props?.params
        },
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
        }
    })
}

const addContractor = async (props) => {
    return await callAPI({
        route: "contractors/",
        method: "post",
        signal: props?.signal,
        data: props?.data,
        params: {
            ...getAuthParams(),
            ...props?.params
        },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
        }
    })
}

const editContractor = async (props) => {
    return await callAPI({
        route: "contractors/" + props?.id,
        method: "put",
        signal: props?.signal,
        data: props?.data,
        params: {
            ...getAuthParams(),
            ...props?.params
        },
        headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Accept: 'application/json',
            ...props?.headers
        }
    })
}

const deleteContractor = async (props) => {
    return await callAPI({
        route: "contractors/" + props?.data?.id,
        method: "delete",
        signal: props?.signal,
        params: getAuthParams(),
        headers: {}
    })
}

const getContractorList = async (props) => {
    return await callAPI({
        route: "contractors/",
        method: "get",
        signal: props?.signal,
        params: {
            ...getAuthParams(),
            ...props?.params,
            show_list: 1
        },
        headers: {}
    })
}

const contractorAPI = {
    getContractors,
    addContractor,
    editContractor,
    deleteContractor,
    getContractorList,
}

export default contractorAPI

